import React, { useContext, useEffect, useState } from 'react';
import { Link, Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { GemsPage, DailyGems, StoreTransactionsPage, InsufficientBalanceModal, StoreItemPurchaseModal } from '../../components/CDHStoreComponents';
import styles from './CDHStore.module.scss';
import { ABIContext, TokenContext, TYPES } from '../../components/Context';
import { createContract } from '../../services/contractService';
import { Web3Context } from '../../web3';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { getSignMessage, verifyOrder, purchaseItem, setTowerAllowance } from '../../services/storeServices';
import { ethers } from 'ethers';
import { PolygonNetworkInfo } from '../../services/networkServices';
import firebase from "firebase";
import { useCookies } from 'react-cookie';
import { IpContext } from '../../components/Context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { fetchTowerBalance } from '../../components/Context/Actions';
import closeIcon from '../../assets/icons/btn-close-X.svg';
import IconShopGems from '../../assets/imgs/store/shop_gems.png';
import IconShopDailyGems from '../../assets/imgs/store/shop_daily_gems.png';
import IconShopStarterPack from '../../assets/imgs/store/shop_starter_pack.png';
import IconShopTimedOffers from '../../assets/imgs/store/shop_timed_offers.png';
import IconShopSupplyDepot from '../../assets/imgs/store/shop_supply_depot.png';
import IconShopNFTs from '../../assets/imgs/store/shop_nfts.png';
import CDHLogo from '../../assets/imgs/store/CDH_logo.png';
import IconGem from '../../assets/imgs/bind/icon-gem.png';
// import IconVIP from '../../assets/icons/store/icon_item_qty_logo.png';
import { StarterPacks } from '../../components/CDHStoreComponents/StarterPacks';
import { TimedOffers } from '../../components/CDHStoreComponents/TimedOffers';
import { SupplyDepotPage } from '../../components/CDHStoreComponents/SupplyDepotPage';
import { NFTPage } from '../../components/CDHStoreComponents/NFTPage';
import { Login } from '../../components';

import LoginAvatar from '../../assets/imgs/avatar_narrator_v2.png';
import LogoCDH from '../../assets/imgs/cdh-logo.png';
import IconAndroid from '../../assets/icons/icon-android.png';
import IconApple from '../../assets/icons/icon-apple\ store.png';

const CDHStore = () => {
    const [t] = useTranslation();
    const location = useLocation();
    const currentPath = location.pathname.split("/")[2];
    const [loggedIn, setLoggedIn] = useState(false);
    const [userDetails, setUserDetails] = useState({});
    const [siwaCookies, removeSiwaCookies] = useCookies(['SiwaAuthId']);
    const { isInChina } = useContext(IpContext);
    const { selectedAccount, web3, provider, connect, switchNetwork, networkId} = useContext(Web3Context);
    const [abiConfig, abiDispatch] = useContext(ABIContext);
    const {
        polygonDeploymentContext,
        polygonProvider,
        storeContract,
    } = abiConfig;
    const [tokenState, tokenDispatch] = useContext(TokenContext);
    const [browserFingerPrint, setBrowserFingerPrint] = useState('');
    const [showInsufficientBalanceModal, setShowInsufficientBalanceModal] = useState(false);
    const [walletInfo, setWalletInfo] = useState({});
    const [wrongWallet, setWrongWallet] = useState(false);
    const [messageModal, setMessageModal] = useState({
        show: false,
        completed: false,
        title: '',
        modalType: '',
        description: ''
    });
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [cookies, setCookies] = useCookies(['showWelcomeModalWebStore']);

    const cdhGpLink = "https://go.onelink.me/bUzl/9c836b67";
    const cdhAppStoreLink = "https://go.onelink.me/VHLW/e01c1c3f";

    const Categories = [
        {
            name: 'Timed Offers',
            image: IconShopTimedOffers,
            location: 'timed-offers'
        },
        {
            name: 'Starter Packs',
            image: IconShopStarterPack,
            location: 'starter-packs'
        },
        {
            name: 'Daily Gems',
            image: IconShopDailyGems,
            location: 'daily-gems'
        },
        {
            name: 'Gems',
            image: IconShopGems,
            location: 'gems'
        },
        {
            name: 'Supply Depot',
            image: IconShopSupplyDepot,
            location: 'supply-depot'
        },
        {
            name: 'NFTs',
            image: IconShopNFTs,
            location: 'nfts'
        },
    ];

    useEffect(() => {
        (async () => {
            const fpPromise = FingerprintJS.load();
            fpPromise
                .then(fp => fp.get())
                .then(result => {
                    setBrowserFingerPrint(result.visitorId)
                })
        })();
    }, [])

    useEffect(() => {
        if (polygonDeploymentContext) {
            initializeStoreContract();
        }
    }, [polygonDeploymentContext])

    const initializeStoreContract = async () => {
        try {
            let contract = await createContract(polygonDeploymentContext, 'AssetsStore', provider);

            if (contract) {
                abiDispatch({
                    type: TYPES.INIT_STORE_CONTRACT,
                    payload: {
                        storeContract: contract
                    },
                })
            }
        } catch (err) {
            console.log("Error initializing store contract.")
        }
    }

    const delayCall = (fnCallback, delayTime) => {
        return new Promise(res => setTimeout(async () => {
            await fnCallback();
            res();
        }, delayTime));
    }

    const SignVerifyPurchase = async (itemId, itemName, itemPrice, onPurchaseSuccess, onPurchasePending, onPurchaseFail, modalDisplayHandler) => {
        try {
            if (!loggedIn || !userDetails) {
                setShowLoginModal(true);
                return;
            }

            if (!selectedAccount) {
                connect();
                return;
            }

            if (walletInfo?.WalletId?.toLowerCase() !== selectedAccount?.toLowerCase()) {
                setWrongWallet(true);
                return;
            }

            let switchNetworkResponse = await switchNetwork(PolygonNetworkInfo);
            if (!switchNetworkResponse) {
                return;
            }

            let userTowerBalance = await fetchTowerBalance(80001, selectedAccount, polygonProvider, polygonDeploymentContext, false);
            if(parseInt(userTowerBalance) < parseInt(itemPrice)) {
                setShowInsufficientBalanceModal(true);
                return;
            }

            let signMessageResponse = await getSignMessage(selectedAccount, browserFingerPrint, tokenState.userId, itemId, itemName, itemPrice);
            let signMessage = signMessageResponse.message;

            let ethersProvider = new ethers.providers.Web3Provider(provider);
            let signer = ethersProvider.getSigner();
            let signature = await signer.signMessage(signMessage);

            let verifyRes = await verifyOrder(tokenState.userId, selectedAccount, browserFingerPrint, signature, signMessage, itemId);
            if (verifyRes === "pending") {
                modalDisplayHandler(false);
                setMessageModal({
                    ...messageModal,
                    show: true,
                    completed: true,
                    modalType: 'pending',
                    title: <>{t('PROCESSING')}...</>,
                    description: <div>
                        <div>{t('Previous order is still in progress.')}</div>
                        <div>{t('Please try again later.')}</div>
                    </div>
                });
                return;
            }

            if (verifyRes?.orderSignature && verifyRes?.quantity && verifyRes?.totalAmount) {
                const towerContract = await createContract(polygonDeploymentContext, 'PolygonTower', provider);
                if (!towerContract || !storeContract) {
                    throw new Error("Contracts not found.");
                }
                const allowance = await towerContract.methods.allowance(selectedAccount, storeContract.options.address).call();

                if (parseInt(web3.utils.fromWei(allowance)) < parseInt(itemPrice)) {
                    const MAX_256_BIT_VALUE = web3.utils.toBN(2).pow(web3.utils.toBN(256)).sub(web3.utils.toBN(1));
                    const ApproveAmount = MAX_256_BIT_VALUE.toString(10);

                    let allowanceSuccess = await setTowerAllowance(towerContract, selectedAccount, storeContract.options.address, ApproveAmount, web3);
                    if (!allowanceSuccess) {
                        console.log("Allowance Failed.");
                        return false;
                    }
                }

                let purchase = await purchaseItem(storeContract, web3, selectedAccount, itemId, verifyRes.quantity.toString(), verifyRes.totalAmount.toString(), verifyRes.orderSignature, onPurchasePending);
                if (purchase === 'pending') {
                    modalDisplayHandler(false);
                    setMessageModal({
                        ...messageModal,
                        show: true,
                        completed: true,
                        modalType: 'pending',
                        title: t('Purchase Pending'),
                        description: t('Purchase is still pending. Please wait until the transaction is confirmed.')
                    });
                    return;
                }

                if (purchase === true) {
                    await delayCall(onPurchaseSuccess, 4000);
                    let towerBalance = await fetchTowerBalance(networkId, selectedAccount, polygonProvider, polygonDeploymentContext, false);
                    if (towerBalance) {
                        tokenDispatch({
                            type: TYPES.SET_TOKEN_BALANCE,
                            payload: towerBalance
                        });
                    }
                    return true;
                } else if (!purchase) {
                    throw new Error("Purchase failed.");
                }
            } else {
                throw new Error("No signature or quantity found.");
            }
        } catch (err) {
            console.log(err);
            if (err.code !== 4001) {
                onPurchaseFail();
            }
        }
    }

    const handleSignOut = () => {
        if (siwaCookies.SiwaAuthId != null) {
            removeSiwaCookies('SiwaAuthId', { path: '/' });
        }
        if (!isInChina) {
            firebase.auth().signOut();
        }
        setUserDetails({});
        setWalletInfo({});
        setLoggedIn(false);
        tokenDispatch({
            type: TYPES.SET_USER_ID,
            payload: "",
        });
    }

    const defaultContainer = () => (
        <>
            <div className={styles.store_categories}>
                {Categories.map((category, index) => (
                    <Link to={`/store/${category.location}`}
                        key={index}
                        className={`${styles.category} ${currentPath === category.location && styles.selected_category}`}
                    >
                        <img src={category.image} alt={category.name} />
                        <span className={styles.category_name}>{category.name}</span>
                    </Link>
                ))}
            </div>

            <div className={styles.store_contents}>
                <Switch>
                    <Route exact path='/store/gems' render={() => <GemsPage SignVerifyPurchase={SignVerifyPurchase} />} />
                    <Route exact path='/store/daily-gems' render={() => <DailyGems SignVerifyPurchase={SignVerifyPurchase} />} />
                    <Route exact path='/store/starter-packs' render={() => <StarterPacks SignVerifyPurchase={SignVerifyPurchase} />} />
                    <Route exact path='/store/timed-offers' render={() => <TimedOffers SignVerifyPurchase={SignVerifyPurchase} />} />
                    <Route exact path='/store/supply-depot' render={() => <SupplyDepotPage SignVerifyPurchase={SignVerifyPurchase} />} />
                    <Route exact path='/store/nfts' render={() => <NFTPage SignVerifyPurchase={SignVerifyPurchase} />} />
                    <Route exact path='*'><Redirect to='/store/timed-offers' /></Route>
                </Switch>
            </div>
        </>
    );

    const showModalHandler = (show) => {
        setMessageModal({
            ...messageModal,
            show: show,
        })
    }

    return (
        <div className={styles.cdh_store_container}>
            <div className={styles.cdh_store}>
                <div className={styles.store_header}>
                    <div className={styles.store_title}>
                        <img src={CDHLogo} alt="cdh-logo" className={styles.cdh_logo} />
                        <span>TOWER CDH Web Store</span>
                    </div>
                    {loggedIn &&
                        <div className={styles.player_items}>
                            {/* Commented out VIP level and VIP Points collected in web store */}
                            {/* <div className={styles.player_item}>
                                <img src={IconVIP} alt="vip" />
                                <span>VIP 14 (28312 / 5000)</span>
                            </div> */}
                            <div className={styles.player_item}>
                                <img src={IconGem} alt="gem" />
                                <span>{userDetails?.Currencies?.Gems || 0}</span>
                            </div>
                            <div onClick={handleSignOut} style={{ cursor: "pointer" }}><FontAwesomeIcon icon={faSignOutAlt}/></div>
                            <Link to="/store/transactions" className={styles.order_history_btn}>Order History</Link>
                        </div>
                    }
                </div>


                <div className={styles.store_body}>
                    {/* {(!loggedIn || !userDetails) && */}
                    {showLoginModal &&
                        <Login
                            title={t('Login to TOWER Web Store')}
                            descriptions={t('Please login your CDH User ID to complete your action.')}
                            loginCharacterImage={LoginAvatar}
                            setShow={setShowLoginModal}
                            setLoggedIn={setLoggedIn}
                            setUserDetails={setUserDetails}
                            setWalletInfo={setWalletInfo}
                        />
                    }
                    <Switch>
                        <Route exact path='/store/'><Redirect to='/store/timed-offers' /></Route>
                        <Route exact path='/store/transactions' component={StoreTransactionsPage} />

                        <Route render={defaultContainer} />
                    </Switch>
                </div>
            </div>

            <Modal 
                show={ cookies.showWelcomeModalWebStore !== 'false' } 
                className={styles.welcome_message_modal} 
                contentClassName={styles.welcome_message_modalContent} 
                dialogClassName={styles.welcome_message_modalDialog} 
                onHide={ () => setCookies('showWelcomeModal', 'false') } 
                centered>
                <Modal.Body className={styles.welcome_message_modalBody}>
                    <div className={styles.welcome_message_title}>
                        { t('WELCOME_TO_WEB_STORE') }
                    </div>
                    <div className={styles.welcome_message_description}>
                        <p>{t('ABLE_TO_PURCHASE_WIDE_RANGE_OF_PRODUCTS')}</p>

                        <p>
                            <span>{ t('WELCOME_TO_WEB_STORE_DESCRIPTION') }</span>
                            &nbsp;<span>
                                <a target="_blank" rel="noopener noreferrer" href={'https://medium.com/tower-token/link-your-metamask-to-see-how-much-tower-you-earned-play-to-earn-events-for-july-and-august-2021-5df508a76392'}>{ t('ARTICLE') }</a>
                            </span>&nbsp;
                            <span>{ t('ABOUT_BINDING_PERIOD') }</span>
                        </p>
                    </div>
                    <div className={styles.welcome_message_btn_section}>
                        <Button className={styles.welcome_message_btn} onClick={() => setCookies('showWelcomeModalWebStore', 'false')}>
                            { t('GOT_IT')}
                        </Button>
                    </div>
                </Modal.Body>

                <Modal.Footer className={styles.welcome_message_footer}>
                    <div className={styles.welcome_message_bottom_banner}>
                        <div className={styles.banner_cdh_logo}>
                            <img src={LogoCDH} alt="crazy-defense-heroes" />
                        </div>
                        <div className={styles.banner_text}>
                            { t('WANNA_PLAY_CDH') }
                        </div>
                        <div className={styles.app_link}>
                            <a target="_blank" href={cdhGpLink} rel="noopener noreferrer">
                                <img src={IconAndroid} alt="icon-play-store" />
                            </a>
                        </div>
                        <div className={styles.app_link}>
                            <a target="_blank" href={cdhAppStoreLink} rel="noopener noreferrer">
                                <img src={IconApple} alt="icon-app-store" />
                            </a>
                            
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal show={wrongWallet} className={styles.wrong_wallet_modal} centered contentClassName={styles.wrong_wallet_modalContent} dialogClassName={styles.wrong_wallet_modalDialog} onHide={() => setWrongWallet(false)}>
                <button className={styles.close_btn} onClick={() => setWrongWallet(false)}>
                    <img src={closeIcon} alt="close" />
                </button>
                <Modal.Body bsPrefix={styles.wrong_wallet_modalBody}>
                    <div className={styles.wrong_wallet_title}>{t('WRONG_WALLET_PLEASE_SWITCH_LINKED_WALLET')} ({`${walletInfo?.WalletId?.substr(0,6)}...${walletInfo?.WalletId?.substr(walletInfo?.WalletId?.length - 4)}`})</div>
                    <div className={styles.btn}>
                        <Button variant='cdh-general-blue' onClick={()=> setWrongWallet(false)}>{t('CLOSE').toUpperCase()}</Button>
                    </div>
                </Modal.Body>
            </Modal>

            <InsufficientBalanceModal
                content={{
                    show: showInsufficientBalanceModal,
                    closeModal: () => setShowInsufficientBalanceModal(false),
                    title: 'OOPS.. You do not have enough $TOWER',
                    description: 'Please get more $TOWER to shop',
                    buttonText: 'Get TOWER',
            }} />

            <StoreItemPurchaseModal
                content={{
                    show: messageModal.show,
                    showSetter: showModalHandler,
                    completed: messageModal.completed,
                    title: messageModal.title,
                    modalType: messageModal.modalType,
                    description: messageModal.description,
                    buttonText: t('OK'),
                }}
            />
        </div>
    )
}

export { CDHStore };
